import {
  RESPONSE_FAVORITES,
  FAVORITE_ADD,
  FAVORITE_REMOVE,
} from '../actions/constantsActions';

const initialState = null;

export default function favorites(state = initialState, action) {
  if (action.type === RESPONSE_FAVORITES) {
    return action.favorites;
  }

  if (action.type === FAVORITE_ADD) {
    return state.concat(action.group);
  }

  if (action.type === FAVORITE_REMOVE) {
    return state.filter(item => item.id !== action.group.id);
  }

  return state;
}
